import axios from "axios";
import { BTC_NETWORK } from "./constants";

export const buildMempoolTxnLink = (txid: string) => {
  if (BTC_NETWORK === "mainnet") {
    return `https://mempool.space/tx/${txid}`;
  }

  return `https://mempool.space/${BTC_NETWORK}/tx/${txid}`;
};

export const errorToMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.error || error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }

  return "Unknown error";
};
